import { render } from "./BugunBitecekIsler.vue?vue&type=template&id=bd78ad56"
import script from "./BugunBitecekIsler.vue?vue&type=script&lang=js"
export * from "./BugunBitecekIsler.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__